import { render, staticRenderFns } from "./fieldtype_multi.vue?vue&type=template&id=55c52b38&"
import script from "./fieldtype_multi.vue?vue&type=script&lang=js&"
export * from "./fieldtype_multi.vue?vue&type=script&lang=js&"
import style0 from "./fieldtype_multi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VCombobox,VListItem})
